import { HomeFooter } from "homepage/homeFooter";
import { Header } from "homepage/homeHeader";
import React from "react";
import "./index.css"

export const FAQanaAnswer = () => {
  const isLoggedIn = localStorage.getItem("user");

  return (
    <>
      {/* <div className="home-page"> */}
      <Header />
      <section className="network text-center mt-3">
        <div className="container network-block">
          <div className="row">
            <div className="col-md-12 mb-5">
              <div className="network-content">
                <h3 className="text-center mb-1">
                  <span className="position-relative fw-bold z-1">
                    FAQ{" "}
                    <img
                      src="../../assets/img/front-pages/icons/section-title-icon.png"
                      alt="laptop charging"
                      className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                    />
                  </span>
                </h3>
                {/* <p className="title-slogan px-5 mt-5">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Sodales morbi tristique libero urna sem vitae. Viverra
                  facilisis rhoncus et, nibh nullam vitae laoreet.{" "}
                </p> */}
                <div class="container-xxl flex-grow-1 container-p-y">
                  {/* <div class="faq-header d-flex flex-column justify-content-center align-items-center rounded h-px-300 position-relative">
                    <img
                      src="../../assets/img/pages/header.png"
                      class="scaleX-n1-rtl faq-banner-img"
                      alt="background image"
                    />
                    <h3 class="text-center">Hello, how can we help?</h3>
                    <div class="input-wrapper mb-3 input-group input-group-lg input-group-merge">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="ti ti-search"></i>
                      </span>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <p class="text-center mb-0 px-3">
                      or choose a category to quickly find the help you need
                    </p>
                  </div> */}

                  <div class="row mt-4 pt-2">
                    <div class="col-lg-3 col-md-4 col-12 mb-md-0 mb-3">
                      <div class="d-flex justify-content-between flex-column mb-2 mb-md-0">
                        <ul class="nav nav-align-left nav-pills flex-column">
                          <li class="nav-item">
                            <button
                              class="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#payment"
                            >
                              <i className="ti ti-wallet ti-sm"></i>
                              <span class="align-middle fw-medium">
                                Payment & Cashback
                              </span>
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              class="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#delivery"
                            >
                              <i class="ti ti-id ti-sm"></i>
                              <span class="align-middle fw-medium">
                                Zenosure Card
                              </span>
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              class="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#cancellation"
                            >
                              <i className="ti ti-user-check ti-sm"></i>
                              <span class="align-middle fw-medium">KYC</span>
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              class="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#orders"
                            >
                              <i class="ti ti-user-circle ti-sm" />
                              <span class="align-middle fw-medium">
                                Profile
                              </span>
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              class="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#product"
                            >
                              <i class="ti ti-settings me-1 ti-sm"></i>
                              <span class="align-middle fw-medium">
                                Support
                              </span>
                            </button>
                          </li>
                        </ul>
                        <div class="d-none d-md-block">
                          <div class="mt-4">
                            <img
                              src="../../assets/img/illustrations/girl-sitting-with-laptop.png"
                              class="img-fluid"
                              width="270"
                              alt="FAQ Image"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-9 col-md-8 col-12">
                      <div class="tab-content py-0">
                        <div
                          class="tab-pane fade show active"
                          id="payment"
                          role="tabpanel"
                        >
                          <div class="d-flex mb-3 gap-3">
                            <div>
                              <span class="badge bg-label-primary rounded-2 p-2">
                                <i className="ti ti-wallet ti-lg"></i>
                              </span>
                            </div>
                            <div>
                              <h4 class="mb-0">
                                <span class="align-middle">
                                  Payment & Cashback
                                </span>
                              </h4>
                            </div>
                          </div>
                          <div id="accordionPayment" class="accordion">
                            <div class="card accordion-item active">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  aria-expanded="true"
                                  data-bs-target="#accordionPayment-1"
                                  aria-controls="accordionPayment-1"
                                >
                                  What if while making payment the bank deducts
                                  money from my account but shows that the
                                  transaction is unsuccessful?
                                </button>
                              </h2>

                              <div
                                id="accordionPayment-1"
                                class="accordion-collapse collapse show"
                              >
                                <div class="accordion-body text-start">
                                    If your bank account was debited but the transaction shows as unsuccessful, please contact customer support immediately at { }
                                    <a href="mailto:support@zenosure.com">support@zenosure.com</a>. Provide the transaction details, including the transaction ID and a screenshot of the debit from your bank statement,
                                    to help us resolve the issue quickly. We will investigate the matter and ensure the payment is either successfully processed or refunded to your account.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPayment-2"
                                  aria-controls="accordionPayment-2"
                                >
                                  How cashback works in Zenosure plan?
                                </button>
                              </h2>
                              <div
                                id="accordionPayment-2"
                                class="accordion-collapse collapse">
                                <div class="accordion-body text-start">
                                  Cashbacks are processed to the bank account you provided and will be credited within <b>30 business days</b> from the date of the transaction. We will notify you once the cashback
                                  has been successfully credited.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPayment-3"
                                  aria-controls="accordionPayment-3">
                                  In how many days can I expect the cashback to
                                  be credited to my account?
                                </button>
                              </h2>
                              <div
                                id="accordionPayment-3"
                                class="accordion-collapse collapse">
                                <div class="accordion-body text-start">
                                  You can expect your cashback to be credited to the bank account you provided within <b>30 business days</b>. We will notify you via email
                                   as soon as the cashback is successfully processed.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPayment-4"
                                  aria-controls="accordionPayment-4">
                                  What should I do if I do not receive the
                                  cashback within the time period specified ?
                                </button>
                              </h2>
                              <div
                                id="accordionPayment-4"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                    If you have not received your cashback within the specified 30 business days, please follow these steps:
                                    <ol class="list-with-spacing">
                                        <li><b>Check your bank statement:</b> First, verify that the cashback has not been credited to your bank account by checking your statement for the full 30-day period.</li>
                                        <li><b>Contact customer support:</b> If you confirm the cashback is missing, please email our support team at{" "} <a href="mailto:support@zenosure.com">
                                               support@zenosure.com</a>.</li>
                                        <li><b>Provide transaction details:</b> To help us resolve the issue quickly, include the following information in your email:
                                              <ul class="ul-bullet-style">
                                                <li>Your full name and registered email address.</li>
                                                <li>Your membership or plan details.</li>
                                                <li>The transaction date and amount for which the cashback is due.</li>
                                                <li>A screenshot of your bank statement showing that the cashback was not received. Our team will investigate the matter and ensure the cashback is
                                                    processed to your account as soon as possible.</li>
                                              </ul>
                                        </li>
                                    </ol>
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPaymentd"
                                  aria-controls="accordionPaymentd">
                                  What is the process for appealing a denied
                                  claim?
                                </button>
                              </h2>
                              <div
                                id="accordionPaymentd"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                    If your claim is denied, you have the right to appeal the decision. Here is the process for submitting an appeal:
                                    <ol class="list-with-spacing">
                                        <li><b>Review the denial letter:</b> Carefully read the denial notice you received. It will state the specific reason for the denial and provide instructions on how to appeal, including any deadlines.
                                        Understanding why your claim was denied is the first crucial step.</li>
                                        <li><b>Gather supporting documents:</b> Collect all relevant documents to support your appeal.This may include:
                                            <ul class="ul-bullet-style">
                                                <li>The denial letter.</li>
                                                <li>Your medical bill with admission date.</li>
                                                <li>Any correspondence you have had with Zenosure regarding the claim.</li>
                                            </ul></li>
                                        <li><b>Contact customer support:</b> Once you have gathered the necessary documents, contact our customer support team at{}" "} <a href="mailto:support@zenosure.com">support@zenosure.com</a>.
                                         In your email, clearly state that you are appealing a denied claim and provide a brief explanation of why you believe the claim should be reconsidered.
                                        Attach all your supporting documents to the email.</li>
                                        <li><b>Await a decision:</b> Our claims team will review your appeal and the additional documents you provided.
                                        We will notify you of the decision as soon as our review is complete. For any further questions during this process, please do not hesitate to contact us at the same email address.</li>
                                    </ol>
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPaymente"
                                  aria-controls="accordionPaymente"
                                >
                                  How do I file a claim for cashback if I paid
                                  fully for services upfront?
                                </button>
                              </h2>
                              <div
                                id="accordionPaymente"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                When you pay for services upfront, there's no need to file a separate claim for your cashback.
                                The cashback is automatically processed based on your payment and will be credited to the bank account you provided during registration.
                                Here's how it works:
                                <ul class="ul-bullet-style">
                                    <li><b>Automatic Processing:</b> Zenosure automatically detects the eligible transaction from your upfront payment.</li>
                                    <li><b>No Claim Form Required:</b> You do not need to fill out any forms or submit receipts. The system handles the process for you.</li>
                                    <li><b>Crediting Timeframe:</b> The cashback will be credited to your account within 30 business days.</li>
                                </ul>
                                If you don't see the cashback in your account after 30 business days, please follow the steps to contact customer support and provide your transaction details for assistance.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPaymentf"
                                  aria-controls="accordionPaymentf"
                                >
                                  When can I report a missing claim?
                                </button>
                              </h2>
                              <div
                                id="accordionPaymentf"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  You can report a missing claim within 15 days of the date of the eligible transaction.
                                  It is crucial to report the missing claim as soon as possible to ensure timely processing.
                                  If you've missed this window, please still contact our customer support team at{" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a> with details of your case.
                                  While we cannot guarantee a resolution, we will do our best to review your situation.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPaymentg"
                                  aria-controls="accordionPaymentg"
                                >
                                  Why my cashback has been declined?
                                </button>
                              </h2>
                              <div
                                id="accordionPaymentg"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                 A decline in cashback can happen for a number of reasons, as each case is unique.
                                 While we need to review your specific details to give you a definitive answer, here are the most common reasons why a cashback might be declined:
                                 <ul class="ul-bullet-style">
                                     <li><b>Failure to meet terms and conditions:</b> Failure to notify affiliate about Zenosure, failure to write Zenosure under referral section, or notifying the affiliate and Zenosure team late.</li>
                                     <li><b>Missing or incorrect information:</b> If there was a discrepancy in the information you provided during the transaction or at registration, the system may not have been able to process the cashback correctly.</li>
                                     <li><b>Reported a missing claim too late:</b> There is a 15-day window to report a missing claim, and if this period has passed, the claim may be declined.</li>
                                 </ul>
                                 To get a precise reason for the decline and to find a solution, please contact our customer support team immediately at {" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>.
                                 To help us investigate as quickly as possible, please include your full name, the transaction details, and any other relevant information you have regarding the purchase.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPaymenth"
                                  aria-controls="accordionPaymenth"
                                >
                                  What should I do if my claim has not been
                                  tracked?
                                </button>
                              </h2>
                              <div
                                id="accordionPaymenth"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                 If your claim has not been tracked, please take the following steps to ensure it can be resolved quickly:
                                 <ol class="list-with-spacing">
                                     <li><b>Wait 72 hours:</b> Sometimes, it can take up to 72 hours for a new claim to appear in our system. Please check again after this time has passed.</li>
                                     <li><b>Contact Customer Support:</b> If your claim is still not visible after 72 hours, please email our support team at{" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>.</li>
                                     <li><b>Provide Key Details:</b> To help us locate your claim, please include the following information in your email:
                                         <ul class="ul-bullet-style">
                                             <li>Your full name and registered email address.</li>
                                             <li>The exact date and time of the transaction.</li>
                                             <li>The amount of the transaction.</li>
                                             <li>Any transaction or reference numbers you received.</li>
                                             <li>A screenshot of the payment confirmation if available.</li>
                                        </ul>
                                     </li>
                                 </ol>
                                 We will investigate the issue and get back to you with an update as soon as possible.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionPaymenti"
                                  aria-controls="accordionPaymenti"
                                >
                                  How to redeem/cashout my cashback at Zenosure?
                                </button>
                              </h2>
                              <div
                                id="accordionPaymenti"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  You do not need to take any action to redeem or cash out your cashback. The process is automatic.
                                  Once your transaction is confirmed, the cashback amount will be transferred directly to the bank account you provided during your registration.
                                  You can expect to receive the cashback within <b>30 business days</b> of the eligible transaction.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="delivery"
                          role="tabpanel"
                        >
                          <div class="d-flex mb-3 gap-3">
                            <div>
                              <span class="badge bg-label-primary rounded-2 p-2">
                               <i class="ti ti-id ti-lg"></i>
                              </span>
                            </div>
                            <div>
                              <h4 class="mb-0">
                                <span class="align-middle">Zenosure Card</span>
                              </h4>
                              {/* <small>Lorem ipsum, dolor sit amet.</small> */}
                            </div>
                          </div>
                          <div id="accordionDelivery" class="accordion">
                            <div class="card accordion-item active">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  aria-expanded="true"
                                  data-bs-target="#accordionDelivery-1"
                                  aria-controls="accordionDelivery-1"
                                >
                                  What is a Zenosure Membership plan, and how
                                  does it work?
                                </button>
                              </h2>

                              <div
                                id="accordionDelivery-1"
                                class="accordion-collapse collapse show"
                              >
                                <div class="accordion-body text-start">
                                  <p>A Zenosure Membership plan is a subscription service designed to provide you with exclusive financial benefits.
                                  By purchasing a Zenosure Subscription Plan, you gain access to a network of "Affiliated Partners" (Hospitals, pharmacies, diagnostics centers etc.,).</p>

                                  Here's how it works:
                                  <ol class="list-with-spacing">
                                      <li><b>Get a plan:</b> First, you register for a Zenosure Membership and choose a Subscription Plan that fits your needs.</li>
                                      <li><b>Transact with partners:</b> When you make a purchase from any of Zenosure's Affiliated Partners, you present your plan details.</li>
                                      <li><b>Receive benefits:</b> Upon a successful transaction, you receive a cashback amount that is later credited to your bank account, depending on the specific offer from that partner.</li>
                                  </ol>
                                  In essence, the plan acts as a key to unlock savings and rewards from a curated list of businesses, helping you get more value from your everyday spending.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDelivery-2"
                                  aria-controls="accordionDelivery-2"
                                >
                                  Who are Zenosure affiliated partners?
                                </button>
                              </h2>
                              <div
                                id="accordionDelivery-2"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Zenosure has a growing network of affiliated partners primarily focused on healthcare. These partners include a range of establishments to help you save on various health-related expenses.
                                  Our current affiliated partners include:
                                  <ul class="ul-bullet-style">
                                      <li>Hospitals</li>
                                      <li>Medical Labs</li>
                                      <li>Pharmacies</li>
                                      <li>Health and Wellness Centers</li>
                                      <li>Clinics</li>
                                  </ul>
                                  We are continuously working to expand our network, so new partners are added regularly. For the most up-to-date and specific list of our affiliated partners in your area,
                                  please{" "} <a href={"/partners"}>click here</a>.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionSubscription"
                                  aria-controls="accordionSubscription"
                                >
                                  What is a Zenosure Subscription Plan?
                                </button>
                              </h2>
                              <div
                                id="accordionSubscription"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Check out our subscription plans{" "}
                                  <a href={isLoggedIn ? "/plans" : "/login"}>
                                    here
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionEligibility"
                                  aria-controls="accordionEligibility"
                                >
                                  Who is eligible to get a Zenosure Membership
                                  Plan?
                                </button>
                              </h2>
                              <div
                                id="accordionEligibility"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  To become a Zenosure member and purchase a plan, you must be 16 years of age or older. Once you have a plan, you can add any family member of any age to it. There are no other hidden conditions or restrictions,
                                  making our membership accessible to a wide range of individuals who wish to benefit from the cashback and discounts offered by our affiliated partners.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscounts"
                                  aria-controls="accordionDiscounts"
                                >
                                  Can I still avail Zenosure discounts if I am
                                  already enrolled to a hospital within the
                                  Zenosure network?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscounts"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  You can avail discounts after a waiting period
                                  of 3 months.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionMembership"
                                  aria-controls="accordionMembership"
                                >
                                  How do I get a Zenosure Membership card?
                                </button>
                              </h2>
                              <div
                                id="accordionMembership"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  The process for getting your Zenosure Membership card is straightforward. Here’s a detailed guide to help you:
                                  <ol class="list-with-spacing">
                                      <li><b>Register Online:</b> Begin by signing up through our fast and secure online registration portal.</li>
                                      <li><b>Select a Plan:</b> Choose the subscription package that best suits your needs and budget.</li>
                                      <li><b>Complete KYC Verification:</b> Once you've selected a plan, you'll need to complete a Know Your Customer (KYC) verification. This is a quick and simple process to verify your identity.</li>
                                      <li><b>Receive Your Digital E-Card:</b> After your KYC is verified, you will receive your Zenosure digital E-card via email and SMS within 48 hours. This card can be used immediately.</li>
                                      <li><b>Start Using Benefits:</b> You can begin using your card at any of our affiliated partner locations, including hospitals, pharmacies, and wellness centers, to instantly avail of discounts and cashbacks.</li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountsf"
                                  aria-controls="accordionDiscountsf"
                                >
                                  How do I use my Zenosure Membership plan with
                                  an Affiliated Partner?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountsf"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Using your Zenosure Membership plan with an affiliated partner is a simple process. Follow these steps to ensure you get your benefits seamlessly:
                                  <ol class="list-with-spacing">
                                      <li><b>Inform Zenosure in advance:</b> Before your visit or within 24 hours of your appointment, inform Zenosure of your planned visit to an affiliated partner. You can do this through the contact details provided on your Zenosure card. This helps us ensure a smooth experience for you.</li>
                                      <li><b>Present your plan:</b> When you arrive at the affiliated partner's location, present your Zenosure digital or physical E-card during the registration or billing process.</li>
                                      <li><b>Mention <i>"Zenosure"</i>:</b> Make sure to mention <b><i>"Zenosure"as your health plan reference</i></b> . If the staff asks for a <b><i>doctor's referral</i></b>, you should also mention <b><i>"Zenosure"</i></b> again.</li>
                                  </ol>
                                  By following these steps, you can ensure that your Zenosure plan benefits are correctly and instantly applied to your bill.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscounts"
                                  aria-controls="accordionDiscounts"
                                >
                                  Is a Zenosure Subscription Plan an insurance
                                  plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscounts"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Zenosure is not an insurance plan.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountsh"
                                  aria-controls="accordionDiscountsh"
                                >
                                  How can I cancel my Zenosure plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountsh"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  To cancel your Zenosure plan, you need to contact our customer support team directly.
                                  Here's how to proceed:
                                  <ul class="ul-bullet-style">
                                      <li><b>Send an email to support:</b> Write an email to{" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>.</li>
                                      <li><b>Provide your details:</b> In your email, include your full name, registered email address, and membership ID to help us identify your account quickly.</li>
                                      <li><b>State your reason:</b> Clearly state your request to cancel your plan. Providing a brief reason for your cancellation can also help us improve our services.</li>
                                      <li><b>Await confirmation:</b> Our team will review your request and process the cancellation. You will receive an email confirming that your plan has been successfully canceled.</li>
                                  </ul>
                                  Before you proceed, we highly recommend that you review the official <a href={"/termsConditions"}>Zenosure cancellation and refund policy</a> for more specific details on any applicable fees, refund eligibility, or cancellation timelines.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountjsg"
                                  aria-controls="accordionDiscountjsg"
                                >
                                  Do you share my personal information with the
                                  third party?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountjsg"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  <p>No. Zenosure does not share or sell your personal information with third parties for marketing purposes without your explicit consent.
                                  We take your privacy seriously and have strict measures in place to protect your data.<br /></p>
                                  <p>Your information is used only for the purpose of providing and improving the Zenosure service, such as processing transactions and managing your membership.
                                  In limited circumstances, your data may be shared with trusted third-party service providers who help us operate our business (e.g., for payment processing or customer support).
                                  These partners are bound by strict confidentiality agreements and are only permitted to use your information to perform the services we have contracted them for.</p>
                                  For more details on how we handle your data, we encourage you to review our <a href={"/privacyPolicy"}>Privacy Policy</a> on our website.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionhDiscounts"
                                  aria-controls="accordionhDiscounts"
                                >
                                  I have an existing Zenosure plan,can I replace
                                  the existing member in the plan?
                                </button>
                              </h2>
                              <div
                                id="accordionhDiscounts"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  No. Once the KYC (Know Your Customer) process is approved, you cannot replace an existing member on your Zenosure plan. The member information is locked to ensure the security and integrity of the plan's benefits.
                                  If there are special circumstances, such as a legal name change due to marriage or other legal reasons, you must contact customer support directly at{" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>.
                                  You will be required to provide valid legal documents as proof of the change, and our team will review the request on a case-by-case basis.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountsi"
                                  aria-controls="accordionDiscountsi"
                                >
                                  How may members can I add in my Zenosure
                                  plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountsi"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Kindly check your subscription plan for more
                                  information.<a href={isLoggedIn ? "/enrolledPlans" : "/login"}>Click here</a>

                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountsb"
                                  aria-controls="accordionDiscountsb"
                                >
                                  I am an NRI, can I purchase zenosure plan
                                  for family members in India?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountsb"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Yes. As a Non-Resident Indian (NRI), you can absolutely purchase a Zenosure plan for your family members living in India. You can also purchase a plan for yourself. Our plans are designed to be accessible to NRIs,
                                  allowing you to provide your loved ones in India with the benefits of our network of affiliated partners.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountc"
                                  aria-controls="accordionDiscountc"
                                >
                                  Can I use my Zenosure plan anywhere in India?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountc"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  At the moment, Zenosure plans can only be used in Karnataka.
                                  We are expanding our network of affiliated partners to other states rapidly, and our goal is to soon be a nationwide service.
                                  Please keep an eye on our official website or social media channels for updates on our expansion.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountd"
                                  aria-controls="accordionDiscountd"
                                >
                                  How is a Zenosure plan different from a health
                                  insurance plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountd"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  A Zenosure plan is fundamentally different from a health insurance plan in its core purpose and function.
                                  <ul class="ul-bullet-style">
                                      <li><b>Zenosure is a Membership Plan, not Insurance:</b> A Zenosure plan is a membership that provides cashbacks and discounts at a network of affiliated partners. It is a savings and benefits program designed to make routine healthcare expenses more affordable.</li>
                                      <li><b>Health Insurance is a Risk Management Tool:</b> A health insurance plan is a financial product that protects you against the financial risk of large, unforeseen medical expenses. It typically covers hospitalization costs, surgery, and other significant medical treatments after you've paid a premium.</li>
                                  </ul>
                                   In short, a Zenosure plan helps you save money on everyday medical and wellness services, whereas a health insurance plan is designed to cover you in the event of a medical emergency or a major health issue. Zenosure and health insurance plans are complementary and can be used together to manage your overall healthcare expenses effectively.
                                   <br /><br /><b>Zenosure is not an insurance plan.</b>
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscounte"
                                  aria-controls="accordionDiscounte"
                                >
                                  Can I enroll my family members or friends for
                                  a Zenosure plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscounte"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Yes. You can enroll anybody depending on your
                                  subscription plan.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscounte"
                                  aria-controls="accordionDiscounte"
                                >
                                  Who are the affiliate partners with Zenosure?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscounte"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  <a href={"/partners"}>Click here</a> to view the complete list of affiliated partners
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountf"
                                  aria-controls="accordionDiscountf"
                                >
                                  Which services are not covered under Zenosure
                                  plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountf"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                 A Zenosure plan provides discounts and cashbacks on products and services from our affiliated partners. However, some services may not be covered, as this can vary from one partner to another.
                                 To determine which specific services are not covered, we recommend you:
                                   <ul class="ul-bullet-style">
                                     <li><b>Review Partner Details:</b> Browse the list of affiliated partners, <a href={"/partners"}>click here</a>. Each partner's page will have specific details about the services that are eligible for Zenosure benefits and any restrictions that may apply.</li>
                                     <li><b>Contact the Partner Directly:</b> Before a visit, you can contact the affiliated partner's clinic or hospital directly to confirm if your specific service or product is covered under the Zenosure plan.</li>
                                   </ul>
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountg"
                                  aria-controls="accordionDiscountg"
                                >
                                  Is there a cap on the cashback I receive
                                  through Zenosure plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountg"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  <b>Cashback and Taxes</b><br /><br />
                                   No. There is no cap on the total cashback you can receive through your Zenosure plan. You can continue to earn cashback on all eligible transactions.
                                   However, all cashbacks are subject to applicable TDS (Tax Deducted at Source) as mandated by government regulations. The amount of cashback you receive will be credited to your account after the TDS deduction.
                                   Service Area Currently, our services are only available in Karnataka. We are working on expanding our network of affiliated partners to other states and will announce new locations as they become available. Please keep an eye on our website and social media for updates.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscounth"
                                  aria-controls="accordionDiscounth"
                                >
                                  What are the payment methods that can be used
                                  while purchasing Zenosure plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscounth"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  <b>UPI</b>, <b>Cards</b>, <b>Netbanking</b> etc., Payments are accepted.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscounti"
                                  aria-controls="accordionDiscounti"
                                >
                                 I lost my Zenosure card. how do i get an another copy?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscounti"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Zenosure card is a digital card, you can
                                  download it from your dashboard.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountk"
                                  aria-controls="accordionDiscountk"
                                >
                                  Is there a limit to the number of times I can
                                  use my Zenosure card?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountk"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  No. There is no limit.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountl"
                                  aria-controls="accordionDiscountl"
                                >
                                  How can I renew the plan on my Zenosure plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountl"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Renewing your Zenosure plan is a straightforward manual process via the dashboard. Our subscriptions are designed so they will not be auto-renewed without your explicit consent.
                                  You can renew your plan at any time before its expiry to ensure continuous access to your benefits.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountj"
                                  aria-controls="accordionDiscountj"
                                >
                                  Are there any discounts for new members?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountj"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                 Discounts for new members are offered on a seasonal basis and are subject to change. We encourage you to check our Plans page on the Zenosure website regularly to see if there are any active promotions.
                                 Additionally, if you are interested in purchasing memberships in bulk (for a group of 10 or more), please contact us directly. We offer customized pricing and special discounts for larger groups.
                                 You can reach out to our team via the Contact Us page to request a quote.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountn"
                                  aria-controls="accordionDiscountn"
                                >
                                  Do I need to inform Zenosure before using
                                  services with any of the affiliate partners?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountn"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Yes. It is mandatory to inform Zenosure before using services with any of our affiliated partners. This is to ensure a seamless experience and to prevent any issues with your cashback or discount.
                                  Here's the process:
                                  <ul class="ul-bullet-style">
                                      <li><b>For planned visits:</b> Inform us before your visit via email.</li>
                                      <li><b>For emergencies:</b> You must inform us within 24 hours of using the service.</li>
                                  </ul>
                                  Additionally, always remember to explicitly mention "Zenosure" to the affiliate partner's staff during your visit. Failure to inform both Zenosure and the partner may result in your claim being rejected
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountp"
                                  aria-controls="accordionDiscountp"
                                >
                                  Can I share my Zenosure card with anyone else?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountp"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  No. Zenosure card is unique to each
                                  individual.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountq"
                                  aria-controls="accordionDiscountq"
                                >
                                  What should I mention in referral?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountq"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Kindly mention Zenosure in referral.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountr"
                                  aria-controls="accordionDiscountr"
                                >
                                  What if a affiliate refuses to accept the
                                  zenosure card?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountr"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Kindly contact customer support.{" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscounts"
                                  aria-controls="accordionDiscounts"
                                >
                                  Will the card number be same for all members?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscounts"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  No each member will have unique card number.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountt"
                                  aria-controls="accordionDiscountt"
                                >
                                  Zenosure site is down, and I am unable to
                                  access the Zenosure card.What should I do?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountt"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Kindly contact the customer support {" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>.
                                  We advise you to download an offline copy of Zenosure card.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountu"
                                  aria-controls="accordionDiscountu"
                                >
                                  When I go to hospital/pharmacy, whom should I
                                  mention name in referral?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountu"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Kindly mention <b>Zenosure</b> as the referral.
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountp"
                                  aria-controls="accordionDiscountp"
                                >
                                  What if I lost access to my account, can I open a new
                                  account and get a new zenosure plan?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountp"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                 If you have lost access to your Zenosure account, we strongly advise against creating a new one. Your existing membership plan, transaction history, and benefits are all tied to your original account.
                                  Creating a new account would not transfer these details and could lead to complications.
                                 Here's what you should do:
                                 <ol class="list-with-spacing">
                                     <li><b>Contact Customer Support Immediately:</b> Email our support team at{" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>.</li>
                                     <li><b>Provide Necessary Details:</b> In your email, include as much information as possible to help us verify your identity and locate your account.
                                            This may include:
                                        <ul class="ul-bullet-style">
                                            <li>The full name and email address used to register the original account.</li>
                                            <li>The phone number associated with the account.</li>
                                            <li>Any past transaction details (e.g., date of purchase, amount).</li>
                                        </ul>
                                     </li>
                                     <li><b>Follow Instructions:</b> Our team will guide you through the process of recovering access to your original account, which may involve identity verification steps to ensure your account security.
                                            following this process, you can regain access to your existing plan and continue to enjoy all your benefits without any interruption.</li>
                                 </ol>
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountw"
                                  aria-controls="accordionDiscountw"
                                >
                                  I have a child who is less than 5 years and I
                                  do not have any supporting documents.What can
                                  I do?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountw"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Contact customer support.{" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>
                                </div>
                              </div>
                            </div>
                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionDiscountv"
                                  aria-controls="accordionDiscountv"
                                >
                                  Can I upgrade my plans?
                                </button>
                              </h2>
                              <div
                                id="accordionDiscountv"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  All plans are separate and time bound.You can
                                  purchase another plan.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="cancellation"
                          role="tabpanel"
                        >
                          <div class="d-flex mb-3 gap-3">
                            <div>
                              <span class="badge bg-label-primary rounded-2 p-2">
                                <i className="ti ti-user-check ti-lg"></i>
                              </span>
                            </div>
                            <div>
                              <h4 class="mb-0">
                                <span class="align-middle">KYC</span>
                              </h4>
                              {/* <small>Lorem ipsum, dolor sit amet.</small> */}
                            </div>
                          </div>
                          <div id="accordionCancellation" class="accordion">
                            <div class="card accordion-item active">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  aria-expanded="true"
                                  data-bs-target="#accordionCancellation-1"
                                  aria-controls="accordionCancellation-1"
                                >
                                  What are the steps to submit a full KYC?
                                </button>
                              </h2>

                              <div
                                id="accordionCancellation-1"
                                class="accordion-collapse collapse show"
                              >
                                <div class="accordion-body text-start">
                                  <p>
                                    Scheduled delivery orders can be cancelled
                                    72 hours prior to your selected delivery
                                    date for full refund.
                                  </p>
                                  <p class="mb-0">
                                    Parcel delivery orders cannot be cancelled,
                                    however a free return label can be provided
                                    upon request.
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionCancellation-2"
                                  aria-controls="accordionCancellation-2"
                                >
                                  Can I return my product?
                                </button>
                              </h2>
                              <div
                                id="accordionCancellation-2"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  You can return your product within 15 days of
                                  delivery, by contacting our
                                  <a href="javascript:void(0);">support team</a>
                                  , All merchandise returned must be in the
                                  original packaging with all original items.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  aria-controls="accordionCancellation-3"
                                  data-bs-target="#accordionCancellation-3"
                                >
                                  Where can I view status of return?
                                </button>
                              </h2>
                              <div
                                id="accordionCancellation-3"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  <p>
                                    Locate the item from Your{" "}
                                    <a href="javascript:void(0);">Orders</a>
                                  </p>
                                  <p class="mb-0">
                                    Select{" "}
                                    <span class="fw-medium">Return/Refund</span>{" "}
                                    status
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane fade" id="orders" role="tabpanel">
                          <div class="d-flex mb-3 gap-3">
                            <div>
                              <span class="badge bg-label-primary rounded-2 p-2">
                                <i class="ti ti-user-circle ti-lg" />
                              </span>
                            </div>
                            <div>
                              <h4 class="mb-0">
                                <span class="align-middle">Profile</span>
                              </h4>
                              {/* <small>Lorem ipsum, dolor sit amet.</small> */}
                            </div>
                          </div>
                          <div id="accordionOrders" class="accordion">
                            <div class="card accordion-item active">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  aria-expanded="true"
                                  data-bs-target="#accordionOrders-1"
                                  aria-controls="accordionOrders-1"
                                >
                                  Can I change the photo in Zenosure plan?
                                </button>
                              </h2>

                              <div
                                id="accordionOrders-1"
                                class="accordion-collapse collapse show"
                              >
                                <div class="accordion-body text-start">
                                    Yes, you can change the photo on your Zenosure plan. Here's a simple, step-by-step guide to help you:
                                    <ol class="list-with-spacing">
                                        <li><b>Log in to your account:</b> Go to the Zenosure website and log in using your credentials.</li>
                                        <li><b>Go to Profile Settings:</b> Navigate to your account dashboard, find the "Settings" menu, and click on "Profile."</li>
                                        <li><b>Select "Modify Profile":</b> Look for the "Modify" or "Edit" option within your profile details.</li>
                                        <li><b>Upload a new photo:</b> Click on the "Upload New Photo" button and select the image you wish to use.</li>
                                    </ol>
                                    Important: Please ensure the new photo meets the specified format and size requirements to be successfully uploaded.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionOrders-2"
                                  aria-controls="accordionOrders-2"
                                >
                                  How do I update my personal information on my
                                  Member Account?
                                </button>
                              </h2>
                              <div
                                id="accordionOrders-2"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                    To Update Your Personal Information
                                    You can easily update most of your personal details through your online account. Just follow these simple steps:
                                    <ol class="list-with-spacing">
                                        <li><b>Log in to your account:</b> Go to the Zenosure website and log in.</li>
                                        <li><b>Go to Profile Settings:</b> Navigate to "Settings" and then click on "Profile."</li>
                                        <li><b>Modify details:</b> Select the "Modify" or "Edit" option to change your information.</li>
                                        <li><b>Save changes:</b> After making your updates, click on "Modify" or "Save" to confirm the changes.</li>
                                    </ol>
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionOrders-3"
                                  aria-controls="accordionOrders-3"
                                >
                                  How to retrieve the forgotten password?
                                </button>
                              </h2>
                              <div
                                id="accordionOrders-3"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  If your password is not working, do not worry. You can reset it by using the "Forgot Password" link on the login page.
                                  If you are still facing issues, please contact our customer support team for assistance{" "}<a href="mailto:support@zenosure.com"> support@zenosure.com</a>
                                  Our support team will help you verify your identity and regain access to your account securely.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane fade" id="product" role="tabpanel">
                          <div class="d-flex mb-3 gap-3">
                            <div>
                              <span class="badge bg-label-primary rounded-2 p-2">
                                <i class="ti ti-settings me-1 ti-lg"></i>
                              </span>
                            </div>
                            <div>
                              <h4 class="mb-0">
                                <span class="align-middle">Support</span>
                              </h4>
                              {/* <small>Lorem ipsum, dolor sit amet.</small> */}
                            </div>
                          </div>
                          <div id="accordionProduct" class="accordion">
                            <div class="card accordion-item active">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  aria-expanded="true"
                                  data-bs-target="#accordionProduct-1"
                                  aria-controls="accordionProduct-1"
                                >
                                  Whom should i contact if I encounter issues
                                  while using the plan?
                                </button>
                              </h2>

                              <div
                                id="accordionProduct-1"
                                class="accordion-collapse collapse show"
                              >
                                <div class="accordion-body text-start">
                                  Please contact us at {" "}<a href="mailto:support@zenosure.com">support@zenosure.com</a>.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionProduct-2"
                                  aria-controls="accordionProduct-2"
                                >
                                  How can I contact customer support?
                                </button>
                              </h2>
                              <div
                                id="accordionProduct-2"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Please contact us at {" "}<a href="mailto:support@zenosure.com">support@zenosure.com</a>.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionProduct-3"
                                  aria-controls="accordionProduct-3"
                                >
                                  What happens if I have a complaint or need
                                  assistance?
                                </button>
                              </h2>
                              <div
                                id="accordionProduct-3"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  Please contact us at {" "}<a href="mailto:support@zenosure.com">support@zenosure.com</a>.
                                </div>
                              </div>
                            </div>

                            <div class="card accordion-item">
                              <h2 class="accordion-header">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#accordionProduct-4"
                                  aria-controls="accordionProduct-4"
                                >
                                  How long does it take for the support team to
                                  reply?
                                </button>
                              </h2>
                              <div
                                id="accordionProduct-4"
                                class="accordion-collapse collapse"
                              >
                                <div class="accordion-body text-start">
                                  We aim to respond to all customer support inquiries within 24 business hours. Please note that our response time may be longer on weekends or public holidays. To help us assist you as quickly as possible,
                                  please provide all relevant details and your registered account information in your initial email.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-5">
                    <div class="col-12 text-center mb-4">
                      <div class="badge bg-label-primary">Question?</div>
                      <h4 class="my-2">You still have a question?</h4>
                      <p>
                        If you can't find question in our FAQ, you can contact
                        us. We'll answer you shortly!
                      </p>
                    </div>
                  </div>
                  <div class="row text-center justify-content-center gap-sm-0 gap-3">
{/*                        TODO: To be enabled when a phone number is available */}
{/*                     <div class="col-sm-6"> */}
{/*                       <div class="py-3 rounded bg-faq-section text-center"> */}
{/*                         <span class="badge bg-label-primary my-3 rounded-2 p-2"> */}
{/*                           <i class="ti ti-phone ti-md"></i> */}
{/*                         </span> */}
{/*                         <h4 class="mb-2"> */}
{/*                           <a class="text-body" href="tel:+(810)25482568"> */}
{/*                             + (810) 2548 2568 */}
{/*                           </a> */}
{/*                         </h4> */}
{/*                         <p>We are always happy to help</p> */}
{/*                       </div> */}
{/*                     </div> */}
                    <div class="col-sm-6">
                      <div class="py-3 rounded bg-faq-section text-center">
                        <span class="badge bg-label-primary my-3 rounded-2 p-2">
                          <i class="ti ti-mail ti-md"></i>
                        </span>
                        <h4 class="mb-2">
                          <a class="text-body" href="mailto:help@help.com">
                            support@zenosure.com
                          </a>
                        </h4>
                        <p>Best way to get a quick answer</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <HomeFooter />
      {/* </div> */}
    </>
  );
};
